<template lang="pug">
  v-row(align="center")
    v-col(md="5" sm="5" cols="6")
      v-img.elevation-5.captcha-img(
        v-if="!loading"
        :src="image"
        @click="loadCaptcha"
      )
      v-skeleton-loader.captcha-img--loading(
        v-else
        type="image"
      )
    v-col(md="7" sm="7" cols="6")
      v-text-field(
        v-bind="$attrs"
        label="Введите символы с картинки"
        @input="$emit('input', $event)"
      )
</template>

<script>
const addBase64Prefix = (image) => `data:image/jpeg;base64,${image}`;

export default {
  name: 'CaptchaField',
  props: {
    method: { type: Function, required: true },
  },
  data: () => ({
    loading: false,
    image: null,
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadCaptcha();
      this.$emit('inizialized', this.loadCaptcha);
    },
    async loadCaptcha() {
      this.loading = true;
      await this.$rHandler(
        this.method(),
        ({ data }) => {
          this.image = addBase64Prefix(data.data.image);
          this.$emit('update:data', data.data);
          this.$emit('input', '');
        },
      );
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.captcha-img {
  border-radius: 10px;
  height: 60px;
  cursor: pointer;
}

.captcha-img--loading {
  height: 60px;
  border-radius: 10px;
}
</style>
